import { DeskbarDemo } from "./DeskbarDemo";
import { MediaPlayerDemo } from "./MediaPlayerDemo";
import { StyledEditDemo } from "./StyledEditDemo";

export function AppReproductions() {
	return (
		<section id="app-reproductions" className="demo-category">
			<h1>App Reproductions</h1>
			<DeskbarDemo />
			<StyledEditDemo />
			<MediaPlayerDemo />
		</section>
	);
}
